<template>
  <div>
    <CHeaderNav
      v-if="
        currentUserRole !== Role.systemCandidate &&
        currentUserRole !== Role.customerCandidate &&
        (currentUserRole !== Role.customerUser || isEducationalInstitute)
      "
      class="d-md-down-none mr-auto ml-3 d-flex align-items-center"
      style="max-height: 45px; min-height: 45px"
    >
      <CHeaderNavItem v-for="item in getAcl" :key="item.menu">
        <CDropdown
          v-if="item.menu_items && item.menu_items.length"
          class="nav-dropdown px-2 pt-2"
          add-menu-classes="pt-0"
          :ref="item.menu"
          :click="toggleClass(item.menu)"
          v-on:mouseover.native="show(item.menu)"
          v-on:mouseleave.native="hide(item.menu)"
          :disabled="item.disabled"
        >
          <template #toggler-content>
            <div
              class="d-flex align-items-center text"
              v-if="
                ['dashboard', 'students'].includes(item.menu) &&
                isEducationalInstitute
              "
            >
              <div
                v-if="item.menu === 'dashboard'"
                @click="navigateTo('/recruiter-dashboard', item.menu)"
              >
                <em :class="`${getMenuIcon(item.menu)} mr-1`"></em>
                <span class="ml-2 header-nav">{{ item.label }}</span>
              </div>
              <div
                v-if="item.menu === 'students'"
                @click="navigateTo('/candidate-list', item.menu)"
              >
                <em :class="`${getMenuIcon(item.menu)} mr-1`"></em>
                <span class="ml-2 header-nav">{{ item.label }}</span>
              </div>
            </div>
            <div
              v-else-if="['profile_page'].includes(item.menu)"
              @click="navigateTo('/profile-page', item.menu)"
            >
              <em :class="`${getMenuIcon(item.menu)} mr-1`"></em>
              <span class="ml-2 header-nav">{{ item.label }}</span>
            </div>
            <div class="d-flex align-items-center text" v-else>
              <em :class="`${getMenuIcon(item.menu)} mr-1`"></em>
              <span class="ml-2 header-nav">{{ item.label }}</span>
            </div>
          </template>
          <div v-if="item.menu_items.length">
            <div v-for="sub_menu in item.menu_items" :key="sub_menu.item">
              <CDropdown
                v-if="
                  sub_menu.menu === 'view/edit_job_board' ||
                  sub_menu.menu === 'view_job_board'
                "
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em class="fas fa-list-alt" style="margin-right: 10px"></em>
                    <span>{{
                      sub_menu.menu === "view_job_board"
                        ? "View Job Board"
                        : "View/Edit Job Board"
                    }}</span>
                  </div>
                </template>
                <CDropdownItem
                  to="/jobs-list/status/active"
                  :click="toggleClass('jobs')"
                >
                  <em class="fas fa-briefcase" style="margin-right: 10px"></em>
                  Active Jobs
                </CDropdownItem>
                <CDropdownItem
                  to="/jobs-list/status/inactive"
                  :click="toggleClass('jobs')"
                >
                  <em
                    class="fas fa-calendar-times"
                    style="margin-right: 10px"
                  ></em>
                  Inactive Jobs
                </CDropdownItem>
                <CDropdownItem
                  to="/jobs-list/status/archive"
                  :click="toggleClass('jobs')"
                >
                  <em
                    class="fas fa-square-xmark"
                    style="margin-right: 10px"
                  ></em>
                  Archive Jobs
                </CDropdownItem>
              </CDropdown>
              <CDropdownItem
                v-else-if="sub_menu.menu === 'organisation' && isSuperCustomer"
                to="/organisation-relations"
              >
                <em class="fas fa-sitemap" style="margin-right: 10px"></em>
                Marketplace Relationships
              </CDropdownItem>

              <CDropdown
                v-else-if="sub_menu.menu === 'organisation'"
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em class="fas fa-hospital" style="margin-right: 10px"></em>
                    <span>Organisation</span>
                  </div>
                </template>
                <CDropdownItem v-if="!isSuperCustomer" to="/add-organisation">
                  <em class="fas fa-hospital" style="margin-right: 10px"></em>
                  Add Organisation
                </CDropdownItem>
                <CDropdownItem v-if="!isSuperCustomer" to="/organisation-list">
                  <em class="fas fa-hospital" style="margin-right: 10px"></em>
                  {{
                    isEducationalInstitute
                      ? "Organisation List"
                      : "List Organisation"
                  }}
                </CDropdownItem>
              </CDropdown>

              <CDropdown
                v-else-if="sub_menu.menu === 'users'"
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em
                      class="fas fa-user-friends"
                      style="margin-right: 10px"
                    ></em>
                    <span>Users</span>
                  </div>
                </template>
                <CDropdownItem
                  to="/add-contactuser"
                  :click="toggleClass('settings')"
                >
                  <em class="fas fa-user-plus" style="margin-right: 10px"></em>
                  Add User
                </CDropdownItem>
                <CDropdownItem to="/list-contactuser">
                  <em class="fas fa-users" style="margin-right: 10px"></em>
                  {{ isEducationalInstitute ? "User List" : "List User" }}
                </CDropdownItem>
              </CDropdown>
              <CDropdown
                v-else-if="sub_menu.menu === 'tutorial_groups'"
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em
                      class="fas fa-user-friends"
                      style="margin-right: 10px"
                    ></em>
                    <span>Tutorial Groups</span>
                  </div>
                </template>
                <CDropdownItem>
                  <em
                    class="fas fa-people-group"
                    style="margin-right: 10px; font-size: 15px"
                  ></em>
                  Create Group
                </CDropdownItem>
              </CDropdown>

              <CDropdown
                v-else-if="sub_menu.menu === 'config'"
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em class="fas fa-cog mr-1"></em>
                    <span>Config</span>
                  </div>
                </template>
                <CDropdownItem
                  to="/theme-and-logo"
                  :click="toggleClass('config')"
                >
                  <em class="fas fa-images mr-2"></em>
                  Theme and Logo
                </CDropdownItem>
                <CDropdownItem
                  to="/onboarding-documents"
                  :click="toggleClass('config')"
                  v-if="!isEducationalInstitute"
                >
                  <em class="fas fa-folder-open mr-2"></em>
                  Document library
                </CDropdownItem>
                <CDropdownItem
                  to="/email-templates"
                  :click="toggleClass('config')"
                >
                  <em class="fas fa-envelope mr-2"></em>
                  Email Config
                </CDropdownItem>
                <!-- <CDropdownItem
                to="/campaign-register"
                :click="toggleClass('config')"
              >
                <em class="fas fa-file-pen mr-2"></em>
                Campaign Form
              </CDropdownItem> -->
              </CDropdown>

              <CDropdown
                v-else-if="
                  item.menu === 'candidates' && sub_menu.menu === 'talent_pool'
                "
                addTogglerClasses="sub-dropdown-item"
                placement="right-start"
                :ref="sub_menu.menu"
                v-on:mouseover.native="show(sub_menu.menu)"
                v-on:mouseleave.native="hide(sub_menu.menu)"
                :disabled="sub_menu.disabled"
              >
                <template #toggler-content>
                  <div class="d-flex align-items-center">
                    <em class="fas fa-user-friends mr-1"></em>
                    <span>Candidates</span>
                  </div>
                </template>
                <CDropdownItem
                  :to="getPathForMenu(sub_menu.menu, item, 'full_registration')"
                  :click="toggleClass('config')"
                >
                  <em class="fas fa-user-check mr-2"></em>
                  Full Registered
                </CDropdownItem>
                <CDropdownItem
                  :to="
                    getPathForMenu(sub_menu.menu, item, 'short_registration')
                  "
                  :click="toggleClass('config')"
                >
                  <em class="fas fa-user mr-2"></em>
                  Short Registered
                </CDropdownItem>
                <CDropdownItem
                  :to="getPathForMenu(sub_menu.menu, item)"
                  :click="toggleClass('config')"
                >
                  <em class="fas fa-user-friends mr-2"></em>
                  All
                </CDropdownItem>
              </CDropdown>
              <CDropdownItem
                v-else-if="sub_menu.menu === 'update_thumbnail'"
                @click="openUpdateThumbnail"
              >
                <em class="fas fa-image mr-2"></em>
                {{ sub_menu.label }}
              </CDropdownItem>
              <CDropdownItem v-else :to="getPathForMenu(sub_menu.menu, item)">
                <em :class="`${getSubMenuIcon(sub_menu.menu)} mr-2`"></em>
                {{ sub_menu.label }}
              </CDropdownItem>
            </div>
          </div>
        </CDropdown>
        <div class="d-flex align-items-center px-2 pt-2 text" v-else>
          <CNavItem :to="getPathForMenu(item.menu, item)">
            <template>
              <div class="text-black">
                <em class="fas fa-list-alt"></em>
                <span class="header-nav ml-2">{{ item.label }}</span>
              </div>
            </template>
          </CNavItem>
        </div>
      </CHeaderNavItem>
    </CHeaderNav>
    <PartnerEdit
      v-if="partnerEditModal.isShowPopup"
      :partnerDetail="partnerEditModal.data"
      :isShowPopup="partnerEditModal.isShowPopup"
      @modalCallBack="partnerModalCallBack"
    />
  </div>
</template>

<script>
import { Role, TFW_CANDIDATE_URL, getLocalOrgDetail } from "@/helpers/helper";
import { mapGetters, mapActions } from "vuex";
import PartnerEdit from "@/containers/Partner/EditPartner";

export default {
  name: "TheDynamicNavHeaders",
  components: {
    PartnerEdit,
  },
  data() {
    return {
      Role,
      getLocalOrgDetail,
      // For Demo Purpose
      roleMenuMap: {
        course_administrator: [
          { menu: "Students", menu_items: ["Talent Pool"] },
          { menu: "Courses", menu_items: ["Course List", "Create Course"] },
          { menu: "Settings", menu_items: ["Config"] },
        ],
        tutor: [
          { menu: "Dashboard", menu_items: ["Dashboard"] },
          { menu: "Students", menu_items: ["Talent Pool"] },
          { menu: "Courses", menu_items: ["Course List", "Create Course"] },
        ],
        support: [
          { menu: "Dashboard", menu_items: ["Dashboard"] },
          { menu: "Students", menu_items: ["Talent Pool"] },
          { menu: "Courses", menu_items: ["Course List", "Create Course"] },
          {
            menu: "Settings",
            menu_items: [
              // "Organisation",
              "Customer Template",
              // "Users",
              // "Config",
              // "Profile Page"
            ],
          },
        ],
      },
      partnerEditModal: {
        data: null,
        isShowPopup: false,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getRoleScopes",
      "getUserAcl",
      "getUserAclv2",
      "getCandidateListUrlBasedOnRole",
      "isJobSupplierFromAccessToken",
      "isSuperCustomer",
      "isServiceProvider",
      "getCustomerTypeIDFromAccessToken",
      "getUser",
      "isPartnerFromAccessToken",
      "getOrgTypeIDFromAccessToken",
      "getPartnerList",
      "getPartnerOrgIdFromAccessToken",
      "isCustomerAdmin",
      "isSystemAdminFromAccessToken",
    ]),
    getAcl() {
      const customer_user_role = this.normalizeKey(
        this.getUser?.users_roles?.[0]?.display_name || "",
      );

      if (
        this.isEducationalInstitute &&
        ["tutor", "course_administrator", "support"].includes(
          customer_user_role,
        )
      ) {
        const userMenus = this.roleMenuMap[customer_user_role] || [];

        const finalAcl = userMenus.map((menuObj) => {
          const filteredItems = menuObj.menu_items.map((submenu) => ({
            label: submenu,
            menu: submenu.toLowerCase().replace(/\s+/g, "_"),
            disabled: false,
          }));

          return {
            label: menuObj.menu,
            menu: menuObj.menu.toLowerCase().replace(/\s+/g, "_"),
            menu_items: filteredItems,
            disabled: false,
          };
        });

        return finalAcl;
      }

      let to_disabled_menus = [];

      if (this.isJobSupplierFromAccessToken) {
        to_disabled_menus = [
          ...to_disabled_menus,
          { menu: "Jobs", menu_items: ["Create Job"] },
          { menu: "Settings", menu_items: ["Job Templates"] },
        ];
      }

      const acl = [];
      const organisationTypes = {
        hospital: 1,
        agency: 3,
        educational_institute: 18,
      };

      if (
        (Object.values(organisationTypes).includes(
          this.getOrgTypeIDFromAccessToken,
        ) ||
          this.isPartnerFromAccessToken) &&
        this.getUserAclv2?.length
      ) {
        return this.getAclV2;
      }

      for (const val of this.getUserAcl || []) {
        let menuItems = [...(val.menu_items || [])];

        if (
          menuItems.includes("Profile Page") &&
          this.currentUserRole !== Role.customerAdmin
        ) {
          menuItems = menuItems.filter((item) => item !== "Profile Page");
        }

        let continueCond = !menuItems.length;
        if (
          this.isPartnerFromAccessToken &&
          !menuItems.length &&
          val.menu === "Dashboard"
        ) {
          continueCond = false;
        }

        if (continueCond) continue;
        const disabledMenuConfig = to_disabled_menus.find(
          ({ menu }) => menu === val.menu,
        );

        const disabledItems = disabledMenuConfig?.menu_items || [];
        const isMenuDisabled = disabledMenuConfig && disabledItems.length === 0;

        let filteredItems = menuItems
          .filter((item) => !disabledItems.includes(item))
          .map((item) => ({
            label: item,
            menu: item.toLowerCase().replaceAll(" ", "_"),
            disabled: false,
          }));

        if (val.menu === "Jobs") {
          if (!this.isEducationalInstitute)
            filteredItems.push({
              label: "Public Job Board",
              menu: "public_job_board",
              disabled: false,
            });
        }

        const hasJobTemplates = filteredItems.some(
          (item) => item.menu === "job_templates",
        );

        if (hasJobTemplates) {
          const jobIndex = acl.findIndex((item) => item.menu === "jobs");
          acl[jobIndex].menu_items.push({
            label: "Job Templates",
            menu: "job_templates",
            disabled: false,
          });

          filteredItems = filteredItems.filter(
            (item) => item.menu !== "job_templates",
          );
        }

        if (!filteredItems.length && !this.isPartnerFromAccessToken) continue;

        acl.push({
          label: val.menu,
          menu: val.menu.toLowerCase().replaceAll(" ", "_"),
          menu_items: filteredItems,
          disabled: isMenuDisabled,
        });
      }

      return acl;
    },

    hasTFMRelationship() {
      return this.getUserAcl?.some((a) => a.menu === "TalentFind");
    },

    getAclV2() {
      const isCustomerAdmin = this.isCustomerAdmin;
      const isSystemAdmin = this.isSystemAdminFromAccessToken;
      const isPartner = this.isPartnerFromAccessToken;
      const MENU_STRUCTURE = [
        {
          menu: "Dashboard",
          menu_items: [
            {
              menu_item: "Dashboard",
              mapped: "Landing Page",
            },
            {
              menu_item: "Management Report",
              mapped: "Management Reports",
              disabled: this.isEducationalInstitute,
            },
          ],
        },
        {
          menu: "Candidates",
          cond_display: !this.isEducationalInstitute,
          menu_items: [
            { menu_item: "Talent Pool", mapped: "Talent Pool" },
            { menu_item: "Recruitment Status", mapped: "Recruitment" },
          ],
        },
        {
          menu: "Students",
          cond_display: this.isEducationalInstitute,
          mapped: "Talent Pool",
          menu_items: [{ menu_item: "Talent Pool" }],
        },
        {
          menu: "Jobs",
          mapped: "Job Board",
          menu_items: [
            { menu_item: "Job List" },
            { menu_item: "Allocate Job", org_types: [3] },
            { menu_item: "Create Job" },
            { menu_item: "View/Edit Job Board" },
            { menu_item: "Job Templates" },
            {
              menu_item: "Public Job Board",
              cond_display: isCustomerAdmin,
            },
          ],
        },
        {
          menu: "Campaign",
          menu_items: [{ menu_item: "Campaign Form", mapped: "Campaigns" }],
        },
        {
          menu: "Settings",
          menu_items: [
            {
              menu_item: "Organisation",
              cond_display: (isCustomerAdmin || isSystemAdmin) && !isPartner,
            },
            { menu_item: "Customer Template", cond_display: !isPartner },
            {
              menu_item: "Users",
              mapped: "User Management",
              cond_display: isCustomerAdmin,
            },
            { menu_item: "Config", cond_display: !isPartner },
            {
              menu_item: "Profile Page",
              cond_display: isCustomerAdmin && !isPartner,
            },
            { menu_item: "Add Profile Page", cond_display: isPartner },
            { menu_item: "Setup AI Web Page", cond_display: isPartner },
            { menu_item: "Update Thumbnail", cond_display: isPartner },
          ],
        },
        {
          menu: "TalentFind",
          cond_display: this.hasTFMRelationship,
          menu_items: [{ menu_item: "Talent Pool" }],
        },
      ];

      const allowedMenus = this.getUserAclv2.map((a) => a.menu);
      const currentOrgId = this.getOrgTypeIDFromAccessToken;
      const toSnakeCase = (str) => str.toLowerCase().replaceAll(" ", "_");

      // Build new array
      const result = MENU_STRUCTURE.reduce((acc, item) => {
        // 1. Hard Gate: Org Type Check
        if (item.org_types && !item.org_types.includes(currentOrgId)) {
          return acc;
        }

        // 2. Permission Check for Parent
        // Rule: If 'mapped' is missing, it's considered default (true)
        const isParentAllowed =
          (!item.mapped || allowedMenus.includes(item.mapped)) &&
          (item.cond_display != undefined ? item.cond_display : true);

        // 3. Filter Menu Items
        let validItems = (item.menu_items || []).filter((mi) => {
          // Check item-level Org restriction
          if (mi.org_types && !mi.org_types.includes(currentOrgId)) {
            return false;
          }

          // Rule: If mi.mapped is missing, it's default.
          // Otherwise, check if it's in allowedMenus.
          const isItemAllowed =
            (!mi.mapped || allowedMenus.includes(mi.mapped)) &&
            (mi.cond_display != undefined ? mi.cond_display : true);

          // Item is visible if BOTH the parent category and the item itself are allowed
          // (This handles the TalentFind case for Org 3 perfectly)
          return isParentAllowed && isItemAllowed;
        });

        // Remove duplicate submenu items
        validItems = validItems.filter(
          (mi, index, self) =>
            index === self.findIndex((t) => t.menu_item === mi.menu_item),
        );

        // 4. Final Build
        if (validItems.length > 0) {
          const menuKey = toSnakeCase(item.menu);

          const existingMenu = acc.find((m) => m.menu === menuKey);

          if (existingMenu) {
            existingMenu.menu_items.push(
              ...validItems.map((mi) => ({
                label: mi.menu_item,
                menu: toSnakeCase(mi.menu_item),
                disabled: mi.disabled != undefined ? mi.disabled : false,
              })),
            );
          } else {
            acc.push({
              label: item.menu,
              menu: menuKey,
              disabled: false,
              menu_items: [
                ...new Map(
                  validItems.map((mi) => [
                    toSnakeCase(mi.menu_item),
                    {
                      label: mi.menu_item,
                      menu: toSnakeCase(mi.menu_item),
                      disabled: mi.disabled != undefined ? mi.disabled : false,
                    },
                  ]),
                ).values(),
              ],
            });
          }
        }
        return acc;
      }, []);

      return result;
    },

    isCurrentUserTypeRecruiter() {
      return (this.currentUserType && this.currentUserType.code === 0) || false;
    },
    currentUserRole() {
      const curRole = this.getRoleScopes.length
        ? this.isCustomerRecruiterUser && !this.isCurrentUserTypeRecruiter
          ? "customer_user"
          : this.getRoleScopes[0]
        : "";
      const roleCheck = {
        customer_recruiter: "customer_recruiter",
        customer_admin: "customer_admin",
      };
      return this.getRoleScopes.length
        ? this.currentUserType?.code
          ? roleCheck[this.currentUserType?.code] || "customer_user"
          : this.getRoleScopes[0]
        : "";
    },
    isEducationalInstitute() {
      return this.getCustomerTypeIDFromAccessToken === 5 || false;
    },
  },
  methods: {
    ...mapActions(["fetchPartners", "updatePartner"]),
    async openUpdateThumbnail() {
      const organisationId = this.getPartnerOrgIdFromAccessToken;
      await this.fetchPartners({
        skip: 0,
        organisation_id: organisationId,
      });
      const currentPartner = this.getPartnerList?.[0];
      this.partnerEditModal.data = currentPartner;
      this.partnerEditModal.isShowPopup = true;
    },
    partnerModalCallBack(action, payload) {
      if (action === false) {
        this.partnerEditModal.isShowPopup = false;
        this.partnerEditModal.data = null;
      } else if (action === true) {
        let appendAction = this.updatePartner(payload);
        Promise.all([appendAction]).then((res) => {
          if (res) {
            this.partnerEditModal.isShowPopup = false;
            this.partnerEditModal.data = null;
          }
        });
      }
    },
    getMenuIcon(menu) {
      switch (menu) {
        case "dashboard":
          return "fas fa-list";
        case "candidates":
          return "fas fa-briefcase-medical";
        case "categories":
          return "fas fa-briefcase-medical";
        case "customers":
          return "fas fa-user-friends";
        case "partners":
          return "fas fa-hospital";
        case "jobs":
          return "fas fa-briefcase";
        case "courses":
          return "fas fa-briefcase";
        case "settings":
          return "fas fa-users-cog";
        case "talentfind":
          return "tfw-icon";
        case "students":
          return "fas fa-graduation-cap";
        case "courses":
          return "fas fa-chalkboard-user";
        case "profile_page":
          return "fas fa-users-cog";
        default:
          return "fas fa-list";
      }
    },
    getSubMenuIcon(menu) {
      switch (menu) {
        case "recruiter_dashboard":
          return "fas fa-chalkboard-teacher";
        case "management_report":
          return "fas fa-chart-line";
        case "talent_pool":
          return "fas fa-user-friends";
        case "students":
          return "fas fa-user-friends";
        case "recruitment_status":
          return "fas fa-user-check";
        case "add_customer":
          return "fas fa-user-plus";
        case "customer_list":
          return "fas fa-users";
        case "add_partner":
          return "fas fa-hospital";
        case "partner_list":
          return "fas fa-list";
        case "create_job":
          return "fas fa-laptop-medical";
        case "job_list":
          return "fas fa-list";
        case "allocate_job":
          return "fas fa-briefcase-medical";
        case "programmes":
          return "fas fa-list-alt";
        case "job_templates":
          return "fas fa-list-alt";
        case "add_candidate":
          return "fas fa-user-plus";
        case "onboarding_docs":
          return "fas fa-folder-open";
        case "theme_and_logo":
          return "fas fa-images";
        case "email_template":
          return "fas fa-envelope";
        case "campaign_form":
          return "fas fa-file-pen mr-2";
        case "short_registration":
          return "fa-solid fa-user-pen";
        case "full_registration":
          return "fa-solid fa-user-pen";
        case "public_job_board":
          return "fas fa-briefcase";
        default:
          return "fas fa-list";
      }
    },
    getPathForMenu(menu, item, pathParams = "") {
      let talent_pool_url = this.getCandidateListUrlBasedOnRole;

      if (item?.menu === "talentfind" || this.isSuperCustomer) {
        talent_pool_url = TFW_CANDIDATE_URL;
        if (this.isSuperCustomer) {
          talent_pool_url = TFW_CANDIDATE_URL.replace("/full_registration", "");
        }
      }

      let path = this.getCandidateListUrlBasedOnRole;

      switch (menu) {
        case "system_dashboard":
          path = "/dashboard";
          break;

        case "dashboard":
          path = this.isServiceProvider
            ? "/spc-dashboard"
            : this.isPartnerFromAccessToken
            ? "/partner-dashboard"
            : "/recruiter-dashboard";
          break;

        case "management_report":
          path = "/management-report";
          break;

        case "add_candidate":
          path = "/add-candidate";
          break;

        case "talent_pool":
          path = talent_pool_url;
          break;

        case "recruitment_status":
          path = "/job-candidates-status?tabIndex=0&tab=allTab";
          break;

        case "add_customer":
          path = "/add-customer";
          break;

        case "customer_list":
          path = "/customer-list";
          break;

        case "add_partner":
          path = "/add-partner";
          break;

        case "partner_list":
          path = "/partner-list";
          break;

        case "create_job":
          path = "/add-job?step=0";
          break;

        case "job_list":
          path = "/job-list?published=%5B27,28,29%5D";
          break;

        case "allocate_job":
          path = "/job-allocation";
          break;

        case "job_templates":
          path = "/list-job-templates";
          break;

        case "onboarding_docs":
        case "document_library":
          path = "/onboarding-documents";
          break;

        case "campaign_form":
          path = "/campaign-register";
          break;

        case "theme_and_logo":
          path = "/theme-and-logo";
          break;

        case "email_templates":
          path = "/email-templates";
          break;

        case "course_list":
          path = "/list-course";
          break;

        case "create_course":
          path = "/add-course";
          break;

        case "list_courses":
          path = "/list-course";
          break;

        case "add_course":
          path = "/add-course";
          break;

        case "customer_template":
          path = "/customer_template";
          break;

        case "profile_page":
          path = "/profile-page";
          break;

        case "add_profile_page":
          path = "/add-profile-page";
          break;
        case "short_registration":
          path = "/add-candidate";
          break;

        case "full_registration":
          path = this.userRegisterLink();
          break;

        case "setup_ai_web_page":
          path = "/setup-ai-web-page";
          break;

        case "public_job_board":
          path = "/config-public-job-board";
          break;

        default:
          path = this.getCandidateListUrlBasedOnRole;
          break;
      }

      if (!pathParams) return path;

      const [basePath, queryString] = path.split("?");
      const finalPath = `${basePath}/${pathParams}`;

      return queryString ? `${finalPath}?${queryString}` : finalPath;
    },
    toggleClass(ref) {
      if (this.$refs[ref] && this.$refs[ref][0]) {
        this.$refs[ref][0].hide(true);
      }
    },
    show(ref) {
      if (
        !(
          ["students", "dashboard"].includes(ref) && this.isEducationalInstitute
        ) &&
        !["profile_page"].includes(ref)
      ) {
        if (this.$refs[ref]) this.$refs[ref][0]._data.visible = true;
      }
    },
    hide(ref) {
      if (
        !(
          ["students", "dashboard"].includes(ref) && this.isEducationalInstitute
        ) &&
        !["profile_page"].includes(ref)
      ) {
        if (this.$refs[ref]) this.$refs[ref][0]._data.visible = false;
      }
    },
    navigateTo(path, ref) {
      this.$refs[ref][0]._data.visible = true;
      return this.$router.push(path);
    },
    userRegisterLink() {
      let { path_acronym, customer_uid, organisation_id, location_id } =
        getLocalOrgDetail();

      let path = `/${path_acronym}/register/${customer_uid}`;
      if (organisation_id) {
        path += `/organisation/${organisation_id}/location/${location_id}`;
      }
      path += `?full-register=true`;
      return path;
    },
    normalizeKey(key) {
      return key.toLowerCase().replace(/\s+/g, "_");
    },
  },
};
</script>
